// extracted by mini-css-extract-plugin
export default {"app":"App_app__kjqwC","main":"App_main__Ouif1"};